<template>
  <span>
    <span v-if="isShowableRegionPulldown">
      <v-select
        v-model="inputedValue"
        item-text="label"
        item-value="value"
        :items="items"
        dense
        outlined
        return-object
        class="original-selectbox"
        hide-details
        :placeholder="$t('common.input_unselected_2')"
        :height="height"
        width="80%"
        :no-data-text="$t('common.input_country-select')"
        :disabled="disabled"
        :filled="disabled"
      >
      </v-select>
    </span>
    <span v-else>
      <v-text-field
        v-model="inputedValue"
        :placeholder="$t('common.input_input_1')"
        outlined
        dense
        hide-details
        :height="height"
        :disabled="disabled"
        :filled="disabled"
      >
      </v-text-field>
    </span>
  </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    //
  },
  props: {
    value: {},
    country: { default: { value: 1, label: '日本' } },
    height: { default: '32px' },
    disabled: { default: false }
  },
  data: () => ({
    items: [],
    isShowableRegionPulldown: false
  }),
  async created() {
    await this.getCountryListFromApi()
    this.createItems()
  },
  methods: {
    ...mapGetters('Common', ['getCountryListFromState']),
    ...mapActions('Common', ['getCountryListFromApi']),

    createItems() {
      const countryList = this.getCountry()
      if (!countryList) {
        this.setNullData()
        return
      }

      const inputedValueTmp = this.inputedValue
      const isObject = inputedValueTmp && typeof inputedValueTmp === 'object'

      const showableRegionPulldown = countryList.showableRegionPulldown
        ? true
        : false
      const regionList = countryList.regionList.map((ele) => {
        return { label: ele.name, value: ele.regionId }
      })

      this.setData(
        showableRegionPulldown,
        showableRegionPulldown ? regionList : []
      )

      const findData = regionList.find(
        (ele) =>
          (!isObject && ele.label === this.inputedValue) ||
          (ele.label === this.inputedValue.label &&
            ele.value === this.inputedValue.value)
      )
      if (isObject) {
        if (!findData) {
          this.inputedValue = null
          return
        }

        // showableRegionPulldown:false のデータをテキストボックスに表示する為に、
        // マスタ登録済み文字列を設定
        if (!showableRegionPulldown) {
          this.inputedValue = this.inputedValue.label
          return
        }
      }

      // 国切り替え時対応
      if (showableRegionPulldown) {
        this.inputedValue = findData
      }
    },
    getCountry() {
      if (!this.country.value) return null

      const countryList = this.getCountryListFromState().find(
        (ele) => ele.countryId === this.country.value
      )
      return countryList ? countryList : null
    },
    setNullData() {
      this.setData(true, [])
      this.inputedValue = null
    },
    setData(isShowableRegionPulldown, selectItems) {
      this.isShowableRegionPulldown = isShowableRegionPulldown
      this.items = selectItems
    }
  },
  computed: {
    inputedValue: {
      get() {
        if (this.isShowableRegionPulldown) {
          return !this.value ? {} : this.value
        } else {
          if (!this.value) {
            return ''
          }
          if (typeof this.value === 'object') {
            return !this.value.label ? '' : this.value
          }
          return this.value
        }
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    country: {
      deep: true,
      handler(newVal, oldVal) {
        this.createItems()
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
